import { render, staticRenderFns } from "./receivingAccountManagementDetail.vue?vue&type=template&id=9950f372&scoped=true"
import script from "./receivingAccountManagementDetail.vue?vue&type=script&lang=js"
export * from "./receivingAccountManagementDetail.vue?vue&type=script&lang=js"
import style0 from "./receivingAccountManagementDetail.vue?vue&type=style&index=0&id=9950f372&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9950f372",
  null
  
)

export default component.exports